import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// singular
export const createApplicantAction = (formData, noRedirect) => ({
  type: actions.CREATE_APPLICANT,
  payload: formData,
  noRedirect
});

export const updateApplicantAction = (id, formData) => ({
  type: actions.UPDATE_APPLICANT,
  payload: {
    id,
    formData,
  },
});

export const deleteApplicantAction = (id) => ({
  type: actions.DELETE_APPLICANT,
  payload: id,
});

// Plural
export const getApplicantsAction = (body) => ({
  type: actions.GET_APPLICANTS,
  payload: body,
});

// singular 
export const getApplicantAction = (applicantId) => ({
  type : actions.GET_APPLICANT,
  payload : applicantId
})

//
export const addEditorReviewApplicant = (applicantId,formData) => ({
  type: actions.ADD_EDITOR_REVEIW,
  payload: {
    applicantId,
    formData
  }
})

export const addFollower = (applicantId, userId) => ({
  type: actions.ADD_FOLLOWER_APPLICANT,
  payload: {
    applicantId,
    userId
  }
})

export const removeFollower = (applicantId, userId) => ({
  type: actions.REMOVE_FOLLOWER_APPLICANT,
  payload: {
    applicantId,
    userId
  }
})

export const getFollowers = (applicantId) => ({
  type: actions.GET_FOLLOWERS,
  payload: applicantId
})




/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const getApplicantSuccessAction = applicant => ({
  type : actions.GET_APPLICANT_SUCCESS,
  payload : applicant
})

export const createApplicantSuccessAction = (applicant) => ({
  type: actions.CREATE_APPLICANT_SUCCESS,
  payload: applicant,
});

export const updateApplicantSuccessAction = (applicant) => ({
  type: actions.UPDATE_APPLICANT_SUCCESS,
  payload: applicant,
});

export const deleteApplicantSuccessAction = (applicantId) => ({
  type: actions.DELETE_APPLICANT_SUCCESS,
  payload: applicantId,
});

//
export const addFollowerSuccess = (payload) => ({
  type: actions.ADD_FOLLOWER_APPLICANT_SUCCESS,
  payload
})

export const removeFollowerSuccess = (payload) => ({
  type: actions.REMOVE_FOLLOWER_APPLICANT_SUCCESS,
  payload
})

export const getFollowersSuccess = (payload) =>({
  type: actions.GET_FOLLOWERS_SUCCESS,
  payload
})


// Plural
export const getApplicantsSuccessAction = (applicants) => ({
  type: actions.GET_APPLICANTS_SUCCESS,
  payload: applicants,
});


/**
 * Misc
 */
export const setApplicantsIsLoadingAction = (isLoading) => ({
  type: actions.SET_APPLICANTS_IS_LOADING,
  payload: isLoading,
});

export const setApplicantsCountAction = (count) => ({
  type: actions.SET_APPLICANTS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_APPLICANTS_SEARCH_VALUE,
  payload: value,
});
